/** Agent glossary tab (M29, LNG-001): terms, synonyms, protected and escalation flags, reply cap. Shell created by WP-M29-SCHEMA1; keys added by WP-M29-GLOSSARY (en and fil together, no dots inside key segments). */
export const glossary = {
  tab: {
    title: "Glossary",
    subtitle:
      "The words your customers and your team use. Synonyms help the agent recognise a term; the flags decide how it is written and when a person steps in. Changes apply from the next message.",
    add: "Add term",
    listLabel: "Glossary terms",
    searchLabel: "Search the glossary",
    searchPlaceholder: "Search terms and synonyms",
    count_one: "{{count}} term",
    count_other: "{{count}} terms",
    scopeAll: "All agents",
    scopeThis: "This agent only",
    sourcePack: "From the {{pack}} pack",
    sourceOperator: "Added by your team",
    synonyms: "Also written",
    edit: "Edit {{term}}",
    remove: "Remove {{term}}",
    loadMore: "Show more terms",
    loadError: "We could not load the glossary",
    loadErrorBody: "Check your connection and try again.",
    readOnly: "You can read the glossary but not change it.",
    added: "Term added",
    saved: "Term saved",
    removed: "Term removed",
    deleteTitle: "Remove “{{term}}”?",
    deleteBody: "The agent stops recognising it from the next message. The change is recorded in the audit log.",
    deleteConfirm: "Remove term",
    cancel: "Cancel",
    capTitle: "Reply length",
    capHint: "Keep replies within a number of words, in every language. Courtesy lines are cut before facts.",
    capSwitch: "Limit the length of replies",
    capSwitchHint: "Off means the agent follows its answer length setting only.",
    capWords: "Most words in a reply",
    capRange: "Enter a whole number from {{min}} to {{max}}.",
    capSave: "Save reply cap",
    capSaved: "Reply cap saved",
    capRemoved: "Reply cap removed",
    capCurrent: "Now: up to {{count}} words",
    capNone: "Now: no cap",
  },
  form: {
    addTitle: "Add a term",
    editTitle: "Edit term",
    description: "A term the agent should recognise, with the other ways people write it.",
    term: "Term",
    termHint: "As you want it written, up to 80 characters.",
    termRequired: "Enter the term.",
    termTooLong: "A term has at most {{max}} characters.",
    locale: "Language of the term",
    localeOptions: { any: "Any language", en: "English", fil: "Filipino", taglish: "Taglish" },
    synonyms: "Synonyms",
    synonymsHint: "Other ways to say it, up to {{max}}. Each one is matched as written.",
    synonymText: "Synonym {{n}}",
    synonymLocale: "Language of synonym {{n}}",
    addSynonym: "Add synonym",
    removeSynonym: "Remove synonym {{n}}",
    scope: "Applies to",
    save: "Save term",
    duplicate: "This term is already in the glossary.",
    full: "The glossary is full. Remove a term to add another.",
    failed: "We could not save the term. Try again.",
  },
  flags: {
    protected: "Never translate",
    protectedHint: "Written exactly as shown, also in Filipino and Taglish answers.",
    escalation: "Escalation word",
    escalationHint: "When a customer writes it, the conversation goes to a person.",
    protectedBadge: "Never translate",
    escalationBadge: "Hands over",
  },
  empty: {
    title: "No terms yet",
    body: "Add the words your customers use, such as product names, local words and Taglish, so the agent understands and writes them the way you do.",
    cta: "Add the first term",
    noMatchTitle: "No term matches “{{query}}”",
    noMatchBody: "Try another word or clear the search.",
    clear: "Clear search",
  },
} as const;
